module.exports = __webpack_public_path__ + "static/img/GI.370e98d0.png";